import React from "react";
import { Outlet } from "react-router";

import { HomePromo } from "../../../assets";
import HomeHeader from "./HomeHeader";

const HomeLayout: React.FC = () => {
  return (
    <div className="bg-primary text-primary-foreground w-screen h-screen flex flex-col">
      <HomeHeader />
      <main className="h-full grid grid-cols-1 lg:grid-cols-2 grid-rows-2 lg:grid-rows-1 p-4 gap-4">
        <div>
          <Outlet />
        </div>
        <div
          style={{
            backgroundImage: `url(${HomePromo})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          {/* <img src={HomePromo} className="w-full h-full object-contain" /> */}
        </div>
      </main>
    </div>
  );
};

export default HomeLayout;
